import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchSalesOverview } from 'queries/sales/overview'
import { SalesFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

const TIME_DIMENSIONS = [
    'tdy',
    'yst',
    'wtd',
    'lastweek',
    'mtd',
    'lastmonth',
    'ytd',
] as const

export function useSalesOverview({
    env,
    accessToken,
    dynamicSubPath,
    location,
    filters,
    timePeriodIndex = 0,
}: SalesFetchProps & { timePeriodIndex?: number }) {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME

    // set time dimensions to query
    const currentDimension = TIME_DIMENSIONS[timePeriodIndex]

    const isToday = currentDimension === 'tdy'

    // create query for current time dimension only
    const query = useQuery({
        queryKey: [QueryKeys.SALES_OVERVIEW, location, currentDimension],
        queryFn: () =>
            fetchSalesOverview({
                env,
                accessToken,
                dynamicSubPath,
                filters: { ...filters, time_dimension: currentDimension },
                trackEvent,
            }),
        staleTime: isToday ? 0 : tenMinutes,
        cacheTime: isToday ? 0 : tenMinutes,
        retry: false,
        refetchOnWindowFocus: false,
    })

    return query
}
